var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLeadsCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80.5C62.0914 80.5 80 62.5914 80 40.5C80 18.4086 62.0914 0.5 40 0.5C17.9086 0.5 0 18.4086 0 40.5C0 62.5914 17.9086 80.5 40 80.5Z",
    fill: "#008FDF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5845_161915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 81
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80.5C62.0914 80.5 80 62.5914 80 40.5C80 18.4086 62.0914 0.5 40 0.5C17.9086 0.5 0 18.4086 0 40.5C0 62.5914 17.9086 80.5 40 80.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5845_161915)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M13.1875 51.1875L42.6875 80.5H80L79.9375 47.375L66.25 33.6875L53.125 20.6875L13.1875 51.1875Z",
    fill: "#1B4B8F"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5845_161915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 81
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80.5C62.0914 80.5 80 62.5914 80 40.5C80 18.4086 62.0914 0.5 40 0.5C17.9086 0.5 0 18.4086 0 40.5C0 62.5914 17.9086 80.5 40 80.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5845_161915)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M33.75 61.1875L53.125 80.5H80V76.5L57.125 53.625L41.25 54.1875L33.75 61.1875Z",
    fill: "#005595"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8125 30H57.75C57 22.5 50.6875 16.6875 43 16.6875C36.3125 16.6875 30.6875 21.0625 28.8125 27.125C27.75 26.4375 26.5 26.0625 25.1875 26.0625C21.5 26.0625 18.5 29.0625 18.5 32.75C18.5 33.3125 18.5625 33.8125 18.6875 34.375C13.9375 35.0625 10.3125 39.375 10.3125 44.25C10.3125 49.625 14.6875 54.25 20.0625 54.25H57.6875C64.25 54.25 69.5625 48.6875 69.5625 42.125C69.625 35.5625 64.3125 30 57.8125 30Z",
    fill: "#D8ECF4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5845_161915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 16,
    width: 60,
    height: 39
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8125 30H57.75C57 22.5 50.6875 16.6875 43 16.6875C36.3125 16.6875 30.6875 21.0625 28.8125 27.125C27.75 26.4375 26.5 26.0625 25.1875 26.0625C21.5 26.0625 18.5 29.0625 18.5 32.75C18.5 33.3125 18.5625 33.8125 18.6875 34.375C13.9375 35.0625 10.3125 39.375 10.3125 44.25C10.3125 49.625 14.6875 54.25 20.0625 54.25H57.6875C64.25 54.25 69.5625 48.6875 69.5625 42.125C69.625 35.5625 64.3125 30 57.8125 30Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5845_161915)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27.5625 50L32.9375 55.375L59.125 55.625L51.8125 48.25L27.5625 50Z",
    fill: "#A3C8D8"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4378 49.0625L40.0003 33.1875L27.5628 49.0625C27.1878 49.5625 27.5003 50.3125 28.1878 50.3125H33.3753V60.0625C33.3753 60.9375 34.0628 61.625 34.9378 61.625H45.0628C45.9378 61.625 46.6253 60.9375 46.6253 60.0625V50.3125H51.8753C52.5003 50.3125 52.8128 49.5625 52.4378 49.0625Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5845_161915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 33,
    width: 26,
    height: 29
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4378 49.0625L40.0003 33.1875L27.5628 49.0625C27.1878 49.5625 27.5003 50.3125 28.1878 50.3125H33.3753V60.0625C33.3753 60.9375 34.0628 61.625 34.9378 61.625H45.0628C45.9378 61.625 46.6253 60.9375 46.6253 60.0625V50.3125H51.8753C52.5003 50.3125 52.8128 49.5625 52.4378 49.0625Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5845_161915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.375 47.875L38.5625 53L37.125 58.1875L46.0625 67.125L51.75 50.875L40 39.125L33.375 47.875Z",
    fill: "#F7F7F7"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39.125V39.1875V39.125L33.375 47.875H37.125V58.1875H42.875V47.875H46.625L40 39.125Z",
    fill: "#C1DD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLeadsCsv);
export default __webpack_public_path__ + "static/media/add_leads_csv.0168e91e80cf10a3bd2d9ca323e895e7.svg";
export { ForwardRef as ReactComponent };